module.exports = __webpack_public_path__ + "application/templates/reset-password/reset-password.template.html";